module.exports = __webpack_public_path__ + "img/icon-file-csv.56a62d68.svg";